import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import TPModal from 'components/TP-UI/TPModal';
import { reduxForm } from 'redux-form';
import { REDUX_FORM_DEFAULT_CONFIG } from 'constants/form';
import ExportMarketingDataForm from '../ExportMarketingDataForm';

const ExportMarketingDataModal = ({
  modalName,
  form,
  loading,
  sources,
  error,
  submitFailed,
  handleSubmit,
  onCancel,
}) => {
  const buttons = useMemo(
    () => [
      {
        label: 'Export',
        primary: true,
        onClick: handleSubmit,
      },
      {
        label: 'Cancel',
        secondary: true,
        onClick: onCancel,
      },
    ],
    [handleSubmit, onCancel],
  );

  return (
    <TPModal
      title="Export Marketing Channels Data"
      modalName={modalName}
      form={form}
      loading={loading}
      buttons={buttons}
      onClose={onCancel}
      onSubmit={handleSubmit}>
      <ExportMarketingDataForm sources={sources} error={error} submitFailed={submitFailed} />
    </TPModal>
  );
};

ExportMarketingDataModal.propTypes = {
  modalName: PropTypes.string.isRequired,
  form: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  sources: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default reduxForm({ ...REDUX_FORM_DEFAULT_CONFIG, enableReinitialize: true })(
  ExportMarketingDataModal,
);
